const actions = {
  GET_DATA_PROYECTS: 'GET_DATA_PROYECTS',
  GET_DATA_FINISH: 'GET_DATA_FINISH',
  GET_DATA_BEGIN: 'GET_DATA_BEGIN',
  SET_DATA_PROYECTS: 'SET_DATA_PROYECTS',
  SET_DATA_NEW_PROYECT: 'SET_DATA_NEW_PROYECT',
  SET_PROYECT_NAME: 'SET_PROYECT_NAME',
  getProyectsData: () => {
    return {
      type: actions.GET_DATA_PROYECTS,
    };
  },
  getDataBegin: () => {
    return {
      type: actions.GET_DATA_BEGIN,
    };
  },
  getDataFinish: () => {
    return {
      type: actions.GET_DATA_FINISH,
    };
  },
  setDocumentsData: (data: any) => {
    return {
      type: actions.SET_DATA_PROYECTS,
      data,
    };
  },
  setNewProyectData: (data: any) => {
    return {
      type: actions.SET_DATA_NEW_PROYECT,
      data,
    };
  },
};

export default actions;
